var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifferenceGamifying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3145_393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6704 31.6H17.2V28.4H20.6704L22.2704 30L20.6704 31.6ZM24.5408 27.7297L24.5328 27.7375L21.9952 25.2H17.1952H14V34.8H17.1952H21.9952L26.8048 29.9922L24.5408 27.7297ZM42.8 31.6H39.3296L37.7296 30L39.3296 28.4H42.8V31.6ZM42.8048 25.2H38.0048L33.1952 30.0078L35.4592 32.2703L35.4672 32.2625L38.0048 34.8H42.8048H46V25.2H42.8048ZM31.6 39.3344V42.8H28.4V39.3344L30 37.7344L31.6 39.3344ZM27.7328 35.4625L27.7392 35.4703L25.2 38.0078V42.8078V46H34.8V42.8078V38.0078L29.9936 33.2L27.7328 35.4625ZM28.4 20.675V17.2H31.6V20.675L30 22.275L28.4 20.675ZM32.2752 24.5453L32.2656 24.5375L34.8 22V17.2V14H25.2V17.2V22L30.0096 26.8078L32.2752 24.5453Z",
    fill: "#FFFF81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3145_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferenceGamifying);
export default __webpack_public_path__ + "static/media/difference_gamifying.2e1bd030f68f6f7237d8263e107d0cbe.svg";
export { ForwardRef as ReactComponent };